(() => {
  function init(root) {
    if (root.dataset.jgaReady) return;
    root.dataset.jgaReady = 'true';
    const select = root.querySelector('[data-jga-workshop]');
    const request = root.querySelector('[data-jga-request]');
    const catalog = root.querySelector('[data-jga-catalog]');
    const form = root.querySelector('form');
    const draftKey = form ? 'gg-jga:' + form.id : '';
    function chooseWorkshop(choice) {
      if (!select || typeof choice !== 'string') return;
      if (![...select.options].some(option => option.value === choice)) {
        select.add(new Option(choice.replace(' - Teamevent', ''), choice));
      }
      select.value = choice;
    }
    if (form) {
      try {
        const saved = JSON.parse(sessionStorage.getItem(draftKey) || 'null');
        if (root.querySelector('[data-jga-error]') && saved && Date.now() - saved.time < 15 * 60 * 1000) {
          for (const field of form.querySelectorAll('input:not([type=hidden]), select, textarea')) {
            const value = saved.fields[field.name];
            if (typeof value !== 'string') continue;
            if (field === select) chooseWorkshop(value);
            else field.value = value;
          }
        }
        sessionStorage.removeItem(draftKey);
      } catch (_) { /* Die Anfrage funktioniert auch bei gesperrtem Browserspeicher. */ }
      form.addEventListener('submit', () => {
        const fields = {};
        for (const field of form.querySelectorAll('input:not([type=hidden]), select, textarea')) {
          if (field.name.startsWith('contact[')) fields[field.name] = field.value;
        }
        try { sessionStorage.setItem(draftKey, JSON.stringify({ time: Date.now(), fields })); } catch (_) {}
      });
    }
    root.addEventListener('click', (event) => {
      const link = event.target.closest('a');
      if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      if (link.hasAttribute('data-jga-open-catalog') && catalog) catalog.open = true;
      if (link.hasAttribute('data-jga-choice') && select) {
        chooseWorkshop(link.dataset.jgaChoice);
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (request && link.hash === '#' + request.id) {
        request.focus({ preventScroll: true });
      }
    });

    const sticky = root.querySelector('[data-jga-sticky]');
    const hero = root.querySelector('[data-jga-hero-cta]');
    const footer = document.querySelector('footer.footer');
    if (sticky && hero && request && 'IntersectionObserver' in window) {
      const visible = new Set();
      const update = () => {
        sticky.hidden = visible.size > 0 || !!root.querySelector('[data-jga-success]');
      };
      const observer = new IntersectionObserver(entries => {
        for (const entry of entries) {
          if (entry.isIntersecting) visible.add(entry.target);
          else visible.delete(entry.target);
        }
        update();
      }, { rootMargin: '0px 0px 80px 0px' });
      [hero, request, footer].filter(Boolean).forEach(element => observer.observe(element));
      const preview = document.getElementById('PBarNextFrameWrapper');
      if (preview && 'ResizeObserver' in window) {
        const sizeObserver = new ResizeObserver(() => {
          root.style.setProperty('--jga-preview-height', Math.ceil(preview.getBoundingClientRect().height) + 'px');
        });
        sizeObserver.observe(preview);
        root.addEventListener('gg-jga-cleanup', () => sizeObserver.disconnect(), { once: true });
      }
      root.addEventListener('gg-jga-cleanup', () => observer.disconnect(), { once: true });
    }
  }
  document.querySelectorAll('[data-gg-jga]').forEach(init);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('[data-gg-jga]').forEach(init);
  });
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-gg-jga]').forEach(root => root.dispatchEvent(new Event('gg-jga-cleanup')));
  });
})();
